import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { formatFileSize, formattedDate, getImageDimensions } from '../../utils/functions';

import { updateMedia } from '../../api/mediaApi';

import copyLink from '../../assets/images/icon-copy.svg'
import deleteIcon from '../../assets/images/delete.svg'
import linkExternal from '../../assets/images/icon-link-external.svg'
import close from '../../assets/images/close.svg'

import fileDocIcon from "../../assets/images/file-doc-icon.svg";
import fileVideoIcon from "../../assets/images/file-video-icon.svg";

const EditMediaPopup = ({ setShowPopup, item, userMedia, setUserMedia, setDeleteConfirmation, usePopupRef }) => {
    const [name, setName] = useState(item?.name || 'File');
    const [dimensions, setDimensions] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [tooltipShow, setTooltipShow] = useState(false);

    const [error, setError] = useState(false);

    const mediaIconSet = {
        'application/doc': fileDocIcon,
        'video/mp4': fileVideoIcon,
        'video/mpeg': fileVideoIcon,
        'video/ogg': fileVideoIcon,
        'video/webm': fileVideoIcon,
        'video/3gpp': fileVideoIcon,
        'video/3gpp2': fileVideoIcon,
        'video/x-msvideo': fileVideoIcon,
        'video/quicktime': fileVideoIcon,
    }

    const itemPreviewUrl = mediaIconSet[item.type] ? mediaIconSet[item.type] : item.url;

    useEffect(() => {
        if ((item.type).includes('image')) {
            getImageDimensions(item.url)
                .then(dimensions => {
                    setDimensions(dimensions);
                })
                .catch(error => {
                    console.error('Error getting image dimensions:', error);
                });
        }
    }, [item]);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSaveButton();
        }
    };

    const handleSaveButton = async () => {
        if (!name.trim()) {
            setError(true);
            return;
        }
        setError(false);
        try {
            setIsLoading(true);
            await updateMedia(item.id, { name });
            if (userMedia) {
                const updatedData = userMedia.map(media =>
                    media.id === item.id ? { ...media, name } : media
                );
                setUserMedia(updatedData);
            }
            setShowPopup(false);
        } catch (error) {
            console.log(error.response?.data?.message || 'Failed to update media');
        } finally {
            setIsLoading(false);
        }
    }

    const clickCopyUrl = () => {
        navigator.clipboard.writeText(item.url);
        setTooltipShow(true);
        setTimeout(() => {
            setTooltipShow(false);
        }, 2000);
    };

    return (
        <>
            <div className="popup-overlay"></div>
            <div className="popupContainer modalPopup edit-media-popup">
                <div className="popupBlock">
                    <div className="popupBlock-wrapper">
                        <div className="mediaGallery" ref={usePopupRef}>
                            <div className="file">
                                <div className='mediaContentWrapper'>
                                    <div className="mediaContentWrapp">
                                        <div className="modalHeader">
                                            <p className='filename'>{item.name}</p>
                                        </div>
                                        <div className="modalContent">
                                            <div className="contentrow">
                                                <div className="modaldate">
                                                    <span className="title">Date:</span>
                                                    <span className='subtext'>{formattedDate(item?.date)}</span>
                                                </div>
                                                <div className="modaltype">
                                                    <span className="title">Type:</span>
                                                    <span className='subtext'>{(item.type)?.split('/')[1]?.toUpperCase()}</span>
                                                </div>
                                                <div className="modalsize">
                                                    <span className="title">Size:</span>
                                                    <span className='subtext'>{formatFileSize(item.size)}</span>
                                                </div>
                                                {dimensions &&
                                                    <div className="modaldimensions">
                                                        <span className="title">Dimensions:</span>
                                                        <span className='subtext'>{dimensions}</span>
                                                    </div>
                                                }
                                            </div>
                                            <form className='modalContentform'>
                                                <div className="formContent">
                                                    <label for="fileName">File Name:</label>
                                                    <input type="text" className={`modalInput ${error ? 'error-border' : ''}`} placeholder="Enter a file name" value={name} onChange={(e) => { setName(e.target.value); setError(''); }} onKeyPress={(e) => { handleKeyPress(e) }} />
                                                </div>
                                                <div className="formContent">
                                                    <label for="url">URL:</label>
                                                    <div className="formURL">
                                                        <input type="url" placeholder={item.url} value={item.url} readOnly className='modalInput' onKeyPress={(e) => { handleKeyPress(e) }} />
                                                        {tooltipShow && <p className="tooltip-text">URL Copied!</p>}
                                                        <div className="formUrlImg">
                                                            <Link to="#">
                                                                <img src={copyLink} alt="copyLink" onClick={clickCopyUrl} />
                                                            </Link>
                                                            <Link to={item.url} target="_blank">
                                                                <img src={linkExternal} alt="linkExternal" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='modalActionsButtons'>
                                                    <div className="modalDelete" onClick={() => { setDeleteConfirmation(true) }}>
                                                        <img src={deleteIcon} alt="deleteIcon" />
                                                        <p className='formContentbtn'>Delete</p>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className=" popup-actions desktop-view btnGroupLink">
                                        <button className="cancel-btn" onClick={() => setShowPopup(false)}>Cancel</button>
                                        <button className="save-btn" onClick={handleSaveButton}>
                                            {isLoading ?
                                                <div className={`ringLoader loaderContinue`}></div>
                                                :
                                                'Save'
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="preview">
                                <div className="modalHeader">
                                    <p className='previewname'>Preview</p>
                                </div>

                                <div className={`modalImg ${(item.type).includes('image') ? 'type-image' : 'type-doc'}`}>
                                    <img src={itemPreviewUrl} alt={item.name} />
                                </div>
                            </div>
                            <div className="popupTop popupClose">
                                <img src={close} onClick={() => setShowPopup(false)} alt="Icon" />
                            </div>
                            <div className="popup-actions mobile-view btnGroupLink">
                                <button className="cancel-btn" onClick={() => setShowPopup(false)}>Cancel</button>
                                <button className="save-btn" onClick={handleSaveButton}>
                                    {isLoading ?
                                        <div className={`ringLoader loaderContinue`}></div>
                                        :
                                        'Save'
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditMediaPopup;